import { Injectable } from '@angular/core';
import { TimeTrial } from '../../core-data-model';
import { ApiService } from '../Api.service';
import { Logger } from '../Logger';
import { UserProfileSettingsService } from '../UserProfileSettings';

@Injectable({ providedIn: 'root' })
export class TimeTrialApiConnect {
    constructor(
        private apiService: ApiService,
        private userProfileSettingsService: UserProfileSettingsService,
        private logger: Logger
    ) {}

    async startTimeTrial(timeTrial: TimeTrial): Promise<TimeTrial> {
        const url = `/api/v4/companies/${this.userProfileSettingsService.currentCompany}/companysettings/timetrial`;

        return await this.apiService
            .post<TimeTrial, TimeTrial>(url, timeTrial)
            .then(([response]) => response)
            .catch((err) => {
                this.handleTimeTrialStartError(err);
                return null;
            });
    }

    private handleTimeTrialStartError(error: string) {
        const message = 'Request to start the time trial failed!';

        this.logger.logError(message, error);
    }
}
